/**
 * Единицы тарификации. Соответствует словарю price_unit
 * @property PIECE = 1, // Штука
 * @property YEAR = 10, // Год
 * @property IN_FACT = 100, // По факту
 * @property BYTE = 11, // Байт
 * @property KILOBYTE = 12, // Килобайт
 * @property MEGABYTE = 13, // Мегабайт
 * @property SECOND = 2, // Секунда
 * @property MINUTE = 3, // Минута
 * @property HOUR = 4, // Час
 * @property DAY = 5, // Сутки
 * @property WEEK = 6, // Неделя
 * @property MONTH = 7, // Месяц
 * @property QUARTER = 8, // Квартал
 * @property HALF_YEAR = 9, // Полугодие

 */

export enum PriceUnits {
  PIECE = 1, // Штука
  YEAR = 10, // Год
  IN_FACT = 100, // По факту
  BYTE = 11, // Байт
  KILOBYTE = 12, // Килобайт
  MEGABYTE = 13, // Мегабайт
  SECOND = 2, // Секунда
  MINUTE = 3, // Минута
  HOUR = 4, // Час
  DAY = 5, // Сутки
  WEEK = 6, // Неделя
  MONTH = 7, // Месяц
  QUARTER = 8, // Квартал
  HALF_YEAR = 9, // Полугодие
}
